import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, homeFor } from "@/context/AuthContext";
import GpsConsentScreen from "@/components/GpsConsentScreen";

export const ProtectedRoute = ({ roles, children, cardSetup = false, consentExempt = false }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0a0a0c]">
        <Loader2 className="h-6 w-6 animate-spin text-amber-400" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  if (user.role === "customer" && !consentExempt && (!user.gps_consent || (!user.card_authorized && !cardSetup))) return <GpsConsentScreen />;
  return children;
};
